module.exports = __webpack_public_path__ + "static/media/home_bg.a545aa58.png";